export default () => ({
  list: [],
  application: {},
  questions: [],
  file: null,
  highlightVariant: {
    questionId: null,
    fieldId: null,
    border: '#0d6efd',
    background: '#0d6efd21',
    class: 'highlight__active'
  },
  appStatus: [
    {
      value: 1,
      label: '公開',
    },
    {
      value: 2,
      label: '限定公開',
    },
    {
      value: 0,
      label: '非公開',
    },
  ],
  planPrices: [],
  allApplication: [],
  appUser: {},
  listAppUser: [],
  listFilterTransaction: [],
  listFilterStep: [],
  quantityAppUser: {
    total: 0,
    complete: 0,
  },
  campaignEmailTemplate: {},
})
